// extracted by mini-css-extract-plugin
module.exports = {"vehicleCardContainer":"az_K3b","vehicleCardDisplayName":"az_L3b","vehicleInfoContainer":"az_M3b","linkText":"az_N3b","vehiclesListContainer":"az_O3b","infoText":"az_P3b"};